import { useState, Fragment, useEffect, useCallback } from "react";
import { Grid, Button } from "@material-ui/core";

import "./ksopBeneficiaryName.css";
/* eslint-disable */

const KsopBeneficiaryName = (props) => {
	const { isPrintable, primaryBeneficiary, contingentBeneficiary } = props;
	// console.log("primaryBeneficiary ===========", props?.primaryBeneficiary);
	const [primaryBeneficiaryDetails, setPrimaryBeneficiaryDetails] = useState([
		{
			id: 1,
			name: "",
			date_of_birth: "",
			relationship: "",
			SSN: "",
			address: "",
			percentage: ""
		},
		{
			id: 2,
			name: "",
			date_of_birth: "",
			relationship: "",
			SSN: "",
			address: "",
			percentage: ""
		},
		{
			id: 3,
			name: "",
			date_of_birth: "",
			relationship: "",
			SSN: "",
			address: "",
			percentage: ""
		},
		{
			id: 4,
			name: "",
			date_of_birth: "",
			relationship: "",
			SSN: "",
			address: "",
			percentage: ""
		}
	]);
	const [contingentBeneficiaryDetails, setContingentBeneficiaryDetails] = useState([
		{
			id: 1,
			name: "",
			date_of_birth: "",
			relationship: "",
			SSN: "",
			address: "",
			percentage: ""
		},
		{
			id: 2,
			name: "",
			date_of_birth: "",
			relationship: "",
			SSN: "",
			address: "",
			percentage: ""
		},
		{
			id: 3,
			name: "",
			date_of_birth: "",
			relationship: "",
			SSN: "",
			address: "",
			percentage: ""
		},
		{
			id: 4,
			name: "",
			date_of_birth: "",
			relationship: "",
			SSN: "",
			address: "",
			percentage: ""
		}
	]);

	return (
		<>
			<div className="ksop-block">
				<div className={isPrintable ? "side-box-small2" : "side-box"}>
					<div className={isPrintable ? "side-text" : ""}>MUST COMPLETE BENEFICIARY DESIGNATION</div>
				</div>
				<div className="content-box-gray">
					<div className="title">BENEFICIARY NAME (S)</div>

					<div className={"content " + (isPrintable ? "font-size-12" : "font-size-14")}>
						<b>
							Before completing, please read the information on the back of this form for direction and
							examples.
						</b>
						<p>
							<b>Note :</b> Unless otherwise provided, if two or more beneficiaries are named, the
							proceeds shall be paid to the named beneficiaries, or to the survivor or survivors, in equal
							shares.
						</p>
						<Grid container spacing={0} className={isPrintable ? "font-size-12" : "font-size-14"}>
							<Grid item xs={3}>
								Name<mark>[Primary Beneficary(S)]</mark>
							</Grid>
							<Grid item xs={1}>
								Date Of Birth
							</Grid>
							<Grid item xs={2}>
								Relationship
							</Grid>
							<Grid item xs={2}>
								Soc. Sec. No.
							</Grid>
							<Grid item xs={3}>
								Address
							</Grid>
							<Grid item xs={1}>
								Percent
							</Grid>
						</Grid>
						{primaryBeneficiaryDetails.map((value, index) => {
							// console.log("primaryBeneficiaryDetails index", index);
							return (
								<div key={index} className={isPrintable ? "font-size-12" : "font-size-14"}>
									<Grid container spacing={0}>
										<Grid item xs={3}>
											<input
												className="input-without-border"
												name="name"
												// size={isPrintable ? "12" : ""}
												type="text"
												value={
													primaryBeneficiary
														? primaryBeneficiary[index]?.name
														: primaryBeneficiaryDetails[index].name
												}
												disabled={
													primaryBeneficiary || primaryBeneficiary[index]?.name ? true : false
												}
											></input>
										</Grid>
										<Grid item xs={1}>
											<input
												className="input-without-border"
												name="date_of_birth"
												type="text"
												// size={isPrintable ? "8" : ""}

												value={
													primaryBeneficiary
														? primaryBeneficiary[index]?.date_of_birth
														: primaryBeneficiaryDetails[index].date_of_birth
												}
												disabled={
													primaryBeneficiary || primaryBeneficiary[index]?.date_of_birth
														? true
														: false
												}
											></input>
										</Grid>
										<Grid item xs={2}>
											<input
												className="input-without-border"
												name="relationship"
												type="text"
												value={
													primaryBeneficiary
														? primaryBeneficiary[index]?.relationship
														: primaryBeneficiaryDetails[index].relationship
												}
												disabled={
													primaryBeneficiary || primaryBeneficiary[index]?.relationship
														? true
														: false
												}
												style={isPrintable ? { marginLeft: "10px" } : { margin: 0 }}
											></input>
										</Grid>
										<Grid item xs={2}>
											<input
												className="input-without-border"
												name="SSN"
												type="text"
												value={
													primaryBeneficiary
														? primaryBeneficiary[index]?.SSN
														: primaryBeneficiaryDetails[index].SSN
												}
												disabled={
													primaryBeneficiary || primaryBeneficiary[index]?.SSN ? true : false
												}
											></input>
										</Grid>
										<Grid item xs={3}>
											<input
												className="input-without-border"
												// size={isPrintable ? "10" : ""}
												type="text"
												name="address"
												value={
													primaryBeneficiary
														? primaryBeneficiary[index]?.address
														: primaryBeneficiaryDetails[index].address
												}
												disabled={
													primaryBeneficiary || primaryBeneficiary[index].address
														? true
														: false
												}
											></input>
										</Grid>
										<Grid item xs={1}>
											<input
												className="input-without-border"
												type="text"
												name="percentage"
												size={isPrintable ? "5" : "10"}
												value={
													primaryBeneficiary
														? primaryBeneficiary[index]?.percentage === 0
															? primaryBeneficiaryDetails[index]?.percentage
															: primaryBeneficiary[index]?.percentage
														: null
												}
												disabled={true}
											></input>
										</Grid>
									</Grid>
									<hr></hr>
								</div>
							);
						})}
						<p>If Primary Beneficiary is not living, pay death benefits to:</p>
						<Grid container spacing={0}>
							<Grid item xs={3}>
								Name<mark>[Contingent Beneficary(S)]</mark>
							</Grid>
							<Grid item xs={1}>
								Date Of Birth
							</Grid>
							<Grid item xs={2}>
								Relationship
							</Grid>
							<Grid item xs={2}>
								Soc. Sec. No.
							</Grid>
							<Grid item xs={3}>
								Address
							</Grid>
							<Grid item xs={1}>
								Percent
							</Grid>
						</Grid>
						{contingentBeneficiaryDetails.map((value, index) => {
							return (
								<div key={index} className={isPrintable ? "font-size-12" : "font-size-14"}>
									<Grid container spacing={0}>
										<Grid item xs={3}>
											<input
												className="input-without-border"
												name="name"
												// size={isPrintable ? "10" : ""}
												type="text"
												value={
													contingentBeneficiary
														? contingentBeneficiary[index]?.name
														: contingentBeneficiaryDetails[index].name
												}
												disabled
											></input>
										</Grid>
										<Grid item xs={1}>
											<input
												className="input-without-border"
												name="date_of_birth"
												type="text"
												// size={isPrintable ? "10" : ""}

												value={
													contingentBeneficiary
														? contingentBeneficiary[index]?.date_of_birth
														: contingentBeneficiaryDetails[index].date_of_birth
												}
												disabled
											></input>
										</Grid>
										<Grid item xs={2}>
											<input
												className="input-without-border"
												name="relationship"
												type="text"
												// size={isPrintable ? "10" : ""}

												value={
													contingentBeneficiary
														? contingentBeneficiary[index]?.relationship
														: contingentBeneficiaryDetails[index].relationship
												}
												disabled
												style={isPrintable ? { marginLeft: "10px" } : { margin: 0 }}
											></input>
										</Grid>
										<Grid item xs={2}>
											<input
												className="input-without-border"
												name="SSN"
												type="text"
												// size={isPrintable ? "10" : ""}

												value={
													contingentBeneficiary
														? contingentBeneficiary[index]?.SSN
														: contingentBeneficiaryDetails[index].SSN
												}
												disabled
											></input>
										</Grid>
										<Grid item xs={3}>
											<input
												className="input-without-border"
												// size={isPrintable ? "10" : ""}
												type="text"
												name="address"
												value={
													contingentBeneficiary
														? contingentBeneficiary[index]?.address
														: contingentBeneficiaryDetails[index].address
												}
												disabled
											></input>
										</Grid>
										<Grid item xs={1}>
											<input
												className="input-without-border"
												type="text"
												size={isPrintable ? "5" : "10"}
												name="percentage"
												value={
													contingentBeneficiary
														? contingentBeneficiary[index]?.percentage === 0
															? contingentBeneficiaryDetails[index]?.percentage
															: contingentBeneficiary[index]?.percentage
														: null
												}
												disabled
											// disabled={contingentBeneficiary[index].percentage ? true : false}
											></input>
										</Grid>
									</Grid>
									<hr></hr>
								</div>
							);
						})}
					</div>
				</div>
			</div>
		</>
	);
};
export default KsopBeneficiaryName;
